module.exports = __webpack_public_path__ + "static/media/testCustomerInventory_logo_small2.db67e5ec.png";